import React from 'react';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useRenewalStatusPolling } from '../../hooks/useRenewalStatusPolling';
import { getRenewalStatusDisplay, reduceRenewalEvents } from '../../service/RenewalStatusService';
import RenewalStatusDialog from '../RenewalStatusDialog/RenewalStatusDialog';
import './RenewalStatusPill.css';

interface RenewalStatusPillProps {
  accountId: string;
}

const PILL_ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  initiated: CircleIcon,
  progress: CircleIcon,
  success: CheckCircleIcon,
  failed: ErrorIcon,
  superseded: NotInterestedIcon
};

function RenewalStatusPill(props: Readonly<RenewalStatusPillProps>): React.ReactElement | null {
  const { accountId } = props;
  const { status } = useRenewalStatusPolling(accountId, 'presence', true);
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);

  // present:false is valid data (no renewal history for this account yet), not an error —
  // per the mockup the pill only exists once a renewal has been triggered at least once.
  if (!status?.present) {
    return null;
  }

  const { state } = reduceRenewalEvents(status.events);
  const { label, icon } = getRenewalStatusDisplay(state);
  const Icon = PILL_ICONS[icon] ?? CircleIcon;

  return (
    <>
      <button
        type='button'
        className={`renewal-status-pill renewal-status-pill--${icon}`}
        onClick={() => setIsDialogOpen(true)}
      >
        <Icon className='renewal-status-pill-icon' />
        <span>{label}</span>
        <ChevronRightIcon className='renewal-status-pill-chevron' />
      </button>
      <RenewalStatusDialog accountId={accountId} isOpen={isDialogOpen} onClose={() => setIsDialogOpen(false)} />
    </>
  );
}

export default RenewalStatusPill;
